import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

// ==================== 静态路由 ====================
const constantRoutes = [
  { path: '/', redirect: '/admin/login' },
  { path: '/key-recharge', name: 'KeyRecharge', component: () => import('@/views/c/KeyRecharge.vue'), meta: { title: '兑换码充值', requireAuth: false } },
  { path: '/wechat-recharge', name: 'WechatRecharge', component: () => import('@/views/c/WechatRecharge.vue'), meta: { title: '微信充值', requireAuth: false } },
  { path: '/admin/login', name: 'Login', component: () => import('@/views/b/Login.vue'), meta: { title: '管理员登录', requireAuth: false } },
  { path: '/order-history', name: 'OrderHistory', component: () => import('@/views/c/OrderHistory.vue'), meta: { title: '充值历史', requireAuth: false } },
  { path: '/wechat-pay', name: 'WechatPay', component: () => import('@/views/c/WechatPay.vue'), meta: { title: '微信支付', requireAuth: false } }
];

const Layout = () => import('@/components/Layout/BLayout.vue');

function resolveComponent(comp) {
  if (!comp || comp === 'Layout' || comp === 'null') return Layout;
  let componentName = comp;
  if (comp === 'userProfile') componentName = 'UserProfile';
  if (componentName.startsWith('views/')) return () => import(`@/${componentName}.vue`);
  if (componentName === 'AiQuery') return () => import('@/views/ai/AiQuery.vue');
  return () => import(`@/views/b/${componentName}.vue`);
}

function normalizeMenuTitle(menu) {
  const componentName = String(menu.component || '')
    .replace(/\.vue$/i, '')
    .split('/')
    .pop();
  if (componentName === 'Dashboard') {
    return '首页';
  }
  if (componentName === 'KeyManage') {
    return '兑换码管理';
  }
  return menu.meta?.title || menu.name || '';
}

function normalizeMenus(menus) {
  return (menus || []).map(menu => {
    const title = normalizeMenuTitle(menu);
    return {
      ...menu,
      name: menu.component === 'Dashboard' || menu.name === 'Dashboard' || menu.name === '仪表盘'
        ? '首页'
        : menu.name,
      meta: {
        ...(menu.meta || {}),
        title
      },
      children: normalizeMenus(menu.children || [])
    };
  });
}

function generateRoutes(menus) {
  const routes = [];
  for (const menu of menus) {
    if (menu.type === 'button') continue;

    const routePath = menu.route || menu.path || '';
    const isParentMenu = !menu.component || menu.component === 'null' || menu.component === null;

    // 父级菜单：只递归子菜单，不生成路由
    if (isParentMenu) {
      if (menu.children && menu.children.length) {
        const childRoutes = generateRoutes(menu.children);
        routes.push(...childRoutes);
      }
      continue;
    }
    console.log(menu, "menu")
    const route = {
      path: routePath,
      name: menu.name || menu.meta?.title || '',
      meta: {
        title: normalizeMenuTitle(menu),
        icon: menu.icon || menu.meta?.icon || '',
        permissions: (menu.meta?.permissions || []).map(p => p.code || p)
      },
      component: resolveComponent(menu.component)
    };

    if (menu.children && menu.children.length) {
      const childMenus = menu.children.filter(child => child.type === 'menu');
      if (childMenus.length) {
        route.children = generateRoutes(childMenus);
      }
    }

    routes.push(route);
  }
  return routes;
}

function filterHiddenMenus(menus) {
  return (menus || [])
    .filter(menu => menu.component !== 'AiQuery' && menu.name !== 'AiQuery')
    .map(menu => ({
      ...menu,
      children: filterHiddenMenus(menu.children || [])
    }));
}

export function addDynamicRoutes(menus) {
  return new Promise((resolve) => {
    const visibleMenus = normalizeMenus(filterHiddenMenus(menus));
    const children = generateRoutes(visibleMenus);
    console.log(children, "children")
    const adminRoute = {
      path: '/admin',
      component: Layout,
      meta: { requireAuth: true },
      children: children
    };
    router.addRoutes([adminRoute]);
    router.addRoutes([
      { path: '/404', component: () => import('@/views/404.vue') },
      { path: '*', redirect: '/404' }
    ]);

    store.commit('user/SET_MENUS', visibleMenus);
    store.commit('user/SET_ASYNC_ROUTES', children);
    store.commit('user/SET_MENUS_LOADED', true);
    resolve();
  });
}

const router = new VueRouter({
  mode: 'history',
  routes: constantRoutes
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 流量充值平台';
  }

  if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      next({ path: '/admin/login', query: { redirect: to.fullPath } });
      return;
    }

    if (!store.state.user?.menusLoaded) {
      try {
        await store.dispatch('user/loadMenus');
        next({ ...to, replace: true });
        return;
      } catch (e) {
        console.error('加载菜单失败', e);
        localStorage.removeItem('admin_token');
        next('/admin/login');
        return;
      }
    }

    if (to.meta.permissions) {
      store.commit('user/SET_PAGE_PERMISSIONS', to.meta.permissions);
    } else {
      store.commit('user/SET_PAGE_PERMISSIONS', []);
    }
    next();
  } else {
    next();
  }
});

export default router;
